import StepWrapper from "@/components/steps/StepWrapper";
import OptionCard from "@/components/ui/OptionCard";
import useQuizStore from "@/store/useQuizStore";

const SingleSelectStep = ({ step }) => {
  const { quizData, setSingleSelection, goToNext } = useQuizStore();
  const selected = quizData[step.field]?.[0] || null;

  const handleSelect = (value) => {
    setSingleSelection(step.field, value);

    setTimeout(() => {
      goToNext();
    }, 300);
  };

  return (
    <StepWrapper title={step.title} subtitle={step.subtitle}>
      <div className="flex flex-col gap-2 md:gap-2.5">
        {step.options.map((option) => (
          <OptionCard
            key={option.value}
            type="radio"
            label={option.label}
            checked={selected === option.value}
            onChange={() => handleSelect(option.value)}
          />
        ))}
      </div>
    </StepWrapper>
  );
};

export default SingleSelectStep;
